<template>
  <v-container fluid class="pa-0 cca">
    <v-container class="mb-15">
      <v-breadcrumbs class="px-0 breadcrumbs" :items="route" divider="/"></v-breadcrumbs>
      <h2 class=" pl-2">{{ $t("cca.title") }}</h2>

      <el-tabs class="pt-10">
        <el-tab-pane label="Consejos y Comités">
          <v-row>
            <v-col>
              <v-data-table
                dense
                disable-sort
                :headers="headers"
                :items="data"
                sort-by="name"
                group-by="category"
                :items-per-page="-1"
                hide-default-footer
              >
                <template v-slot:group.header="{ items, isOpen, toggle }">
                  <th colspan="2" @click="toggle">
                    <v-icon small @click="toggle">{{ isOpen ? "mdi-minus" : "mdi-plus" }} </v-icon>
                    {{ items[0].category }}
                  </th>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </el-tab-pane>
        <el-tab-pane label="Actas">
          <v-row class=" list-wrapper">
            <v-list subheader two-line class="pt-5">
              <!-- <h3>Informes</h3> -->
              <v-list-item
                v-for="erm in actas"
                :key="erm"
                target="_blank"
                :href="`/archivos/actas/${erm}`"
              >
                <v-list-item-avatar>
                  <v-icon class="grey lighten-1" dark v-text="getMime(erm)" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <span class="list-text body-2 grey-2" v-text="erm.toLowerCase()" />
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-row>
        </el-tab-pane>
      </el-tabs>
    </v-container>
  </v-container>
</template>
<script>
import $ from "jquery";
export default {
  name: "cca",
  //{v-container, v-row, v-col, v-data-table}
  data: () => ({
    data: [],
    publicPath: "",
    actas: [],
    route: [
      {
        text: "Transparencia",
        disabled: false,
        to: "/transparencia"
      },
      {
        text: "Consejos, Comités y Academias",
        disabled: true,
        to: "/transparencia/comites-consejos-y-academias"
      }
    ],
    headers: [
      {
        text: "Nombre",
        align: "start",
        value: "name",
        sortable: false,
        groupable: false
      },
      { text: "Category", value: "category", align: "right", groupable: false },
      { text: "Puesto", value: "positions", align: "right", groupable: false }
    ]
  }),
  methods: {
    getMime: function(file) {
      const normalizedFile = file.toLowerCase();
      const dotIndex = normalizedFile.lastIndexOf(".");
      const mime = normalizedFile.substring(dotIndex, file.length);
      switch (mime) {
        case ".pdf":
          return "mdi-file-pdf-box";
        case ".jpg":
          return "mdi-file-image";
        case ".png":
          return "mdi-file-image";
        case ".pptx":
          return "mdi-file-powerpoint";
        default:
          return "mdi-file-document";
      }
    }
  },
  mounted: function() {
    const cca_consolidado = this.$info.transparencia.cca;

    cca_consolidado.forEach((cca, i) => {
      const category = cca.name;
      const tagedData = cca.integrantes.map(integrante => ({
        ...integrante,
        category,
        positions: integrante.positions || "N/A"
      }));
      this.data = [...this.data, ...tagedData];
    });

    this.publicPath = $(location).attr("origin") + "/archivos/actas/";
    $.getJSON(this.publicPath, actas => {
      actas.map(image => {
        if (!image.match("index.php")) {
          this.actas.push(image);
        }
      });
    });
    $(".v-breadcrumbs__item--disabled:first").removeClass("v-breadcrumbs__item--disabled");
    // console.warn(this.data);
    // comites.forEach((comite, i) => this.data.push({ ...comite, category: "comites" }));
    // academias.forEach((academia, i) => this.data.push({ ...academia, category: "academias" }));
  }
};
</script>
<style lang="scss">
.list-text {
  text-transform: capitalize;
}
.list-wrapper {
  padding: 0 2vw;
}
.cca {
  margin-top: 150px;
  .breadcrumbs {
    position: absolute;
    margin-top: -60px !important;
  }
  th {
    //text-transform: capitalize !important;
  }
  tr {
    // text-transform: capitalize;
  }
  td {
    text-transform: capitalize;
  }
}

@media (max-width: 960px) {
  .cca {
    margin-top: 75px;
    .breadcrumbs {
      position: absolute;
      margin-top: -40px !important;
    }
  }
}
</style>
